import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('op_34'),
        action: (obj) => {
          this.createDialog('UpdateSkuProjectDialog', {
            data: [obj],
            columns: this.columns,
            title: i18n.t('op_35'),
            name: i18n.t('op_33'),
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
      },
      {
        label: i18n.t('op_36'),
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: i18n.t('op_36'),
            name: i18n.t('op_33'),
            onManager: this.onManager,
            success: () => {
              this.destroySidePages()
            },
          })
        },
        meta: obj => ({ validate: obj.can_delete }),
      },
    ]
  },
}
